export const CONTAINER_ANALYTICS_SOURCE = 'navigationNext';
export const CONTAINER_EXPERIENCE = 'jiraPageContainer';
export const CONTAINER_EXPERIENCE_ID = null;
export const CONTAINER_APPLICATION = null;
export const CONTAINER_EDITION = null;

export const CONTAINER_BOOTSTRAP_FAIL_LOCATION = 'entry.jira-spa';

const PAGE_CONTAINER_MARK = 'jira-spa/spa-shell/page-container';
export const PAGE_CONTAINER_END_MARK = `_${PAGE_CONTAINER_MARK}.end`;
export const PAGE_LAYOUT_MARK = 'jira-spa/spa-shell/page-layout';
export const GLOBAL_CONTAINERS_MARK = 'jira-spa/spa-shell/global-containers';
export const GLOBAL_CONTAINERS_START_MARK = `_${GLOBAL_CONTAINERS_MARK}.start`;
export const GLOBAL_CONTAINERS_END_MARK = `_${GLOBAL_CONTAINERS_MARK}.end`;
export const GLOBAL_COMPONENTS_MARK = 'jira-spa/spa-shell/global-components';
export const GLOBAL_COMPONENTS_START_MARK = `_${GLOBAL_COMPONENTS_MARK}.start`;
export const GLOBAL_COMPONENTS_END_MARK = `_${GLOBAL_COMPONENTS_MARK}.end`;
export const APP_BASE_CONTAINERS_MARK = 'jira-spa/spa-shell/global-containers/app-base';
export const APP_BASE_CONTAINERS_START_MARK = `_${APP_BASE_CONTAINERS_MARK}.start`;
export const APP_BASE_CONTAINERS_END_MARK = `_${APP_BASE_CONTAINERS_MARK}.end`;
export const ROUTER_CONTAINERS_MARK = 'jira-spa/spa-shell/global-containers/router';
export const ROUTER_CONTAINERS_START_MARK = `_${ROUTER_CONTAINERS_MARK}.start`;
export const ROUTER_CONTAINERS_END_MARK = `_${ROUTER_CONTAINERS_MARK}.end`;
